export function sortResponseData<T>(
  array: T[],
  property: keyof T,
  direction: 'ASC' | 'DESC' = 'ASC'
): T[] {
  return [...array].sort((a, b) => {
    const valueA = a[property];
    const valueB = b[property];

    if (valueA == null && valueB != null) return direction === 'ASC' ? 1 : -1;
    if (valueA != null && valueB == null) return direction === 'ASC' ? -1 : 1;
    if (valueA == null && valueB == null) return 0;

    if (typeof valueA === "number" && typeof valueB === "number") {
      return direction === "ASC" ? valueA - valueB : valueB - valueA;
    }
    if (typeof valueA === "string" && typeof valueB === "string") {
      return direction === "ASC"
        ? valueA.localeCompare(valueB)
        : valueB.localeCompare(valueA);
    }
    if (valueA instanceof Date && valueB instanceof Date) {
      return direction === "ASC"
        ? valueA.getTime() - valueB.getTime()
        : valueB.getTime() - valueA.getTime();
    }
    // Fallback para textos e comparações simples
    if (valueA > valueB) return direction === "ASC" ? 1 : -1;
    if (valueA < valueB) return direction === "ASC" ? -1 : 1;
    return 0;
  });
}
